import React from 'react'

const Gmaps = ({node}) => {
    if(!node.embedCode) {
        return (<div></div>)
    }

    return (
        <div dangerouslySetInnerHTML={{__html: node.embedCode}}/>
    )
}

export default Gmaps